import axios from 'axios';
import {BASE_URL} from '../ApiService/ApiConfig.js'

const URL_BASE_MONITOREO = BASE_URL;

const obtenerConfig = () => {
    const token = localStorage.getItem('jwt').replaceAll('"', '');

    return {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            Authorization: 'Bearer ' + token
        }
    };
};

export const cambiarEmpleadoTurno = async (objDatTurno) => {
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/turnotrabajo/cambioEmpleado`, objDatTurno, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('Error al registrar cambio', error.message);
        // el backend explica el rechazo en texto (ej. turno vacio: no hay nada que reemplazar)
        throw new Error(typeof error.response?.data === 'string' ? error.response.data : 'Error al registrar cambios.');
    }
};

export const obtenerHorarios = async () => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/horario`, obtenerConfig());
        //console.log (response.data)
        return response.data;
    } catch (error) {
        console.error('Error: ', error.message);
        throw new Error('Error al recuperar los datos');
    }
};

export const obtenerDetalleHorario = async (horarioId) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/horariodet/horario/${horarioId}`, obtenerConfig());
        //console.log('JJ00-', response.data);
        return response.data;
    } catch (error) {
        console.error('Error: ', error.message);
        throw new Error('Error al recuperar Detalle horario');
    }
};

export const eliminaHorario = async (horarioId) => {
    try {
        //console.log('ww0:', horarioId);
        const datos = await axios.delete(`${URL_BASE_MONITOREO}/horario/${horarioId}`, obtenerConfig());
        return [];
    } catch (error) {
        console.error('Error: ', error.response);
        throw new Error('Error al borrar');
    }
};

export const adiDetalleHorario = async (objData) => {
    try {
        //console.log('xx00:',objData)
        const response = await axios.post(`${URL_BASE_MONITOREO}/horariodet`, objData, obtenerConfig());
        //console.log ('xx01:', response.data)
        return response.data;
    } catch (error) {
        console.error('Error: ', error.response);
        throw new Error('Error al adicionar');
    }
};

export const eliDetalleHorario = async (horarioDetId) => {
    try {
        const response = await axios.delete(`${URL_BASE_MONITOREO}/horariodet/${horarioDetId}`, obtenerConfig());
        return [];
    } catch (error) {
        console.error('Error: ', error.response);
        throw new Error('Error al Eliminar');
    }
};

export const modificaDetalleHorario = async (objPut) => {
    try {
        //console.log('XX00', objPut);
        const response = await axios.put(`${URL_BASE_MONITOREO}/horariodet`, objPut, obtenerConfig());
        //console.log('XX01', response.data);
        return response.data;
    } catch (error) {
        console.error('Error: ', error.response);
        throw new Error('Error al Modificar');
    }
};

export const adicionaHorario = async (objData) => {
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/horario`, objData, obtenerConfig());
        //console.log('XX', response.data);
        return response.data;
    } catch (error) {
        console.error('Error: ', error.message);
        throw new Error('Error al Grabar');
    }
};

export const creaHorarioComunica = async (objPost) => {
    try {
        //console.log('KKJJ00:', objPost);
        const response = await axios.post(`${URL_BASE_MONITOREO}/comuniconfig`, objPost, obtenerConfig());
        //console.log('KKJJ01:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error: ', error);
        throw new Error('Error al crear configuracion de horario');
    }
};

export const creaHorarioComTotal = async (objPost) => {
    //console.log('JJ100:', objPost);
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/comuniconfig/lotes`, objPost, obtenerConfig());
        //console.log('JJ101:', response.data);
    } catch (error) {
        console.error('Error: ', error);
        throw new Error('Error al crear configuracion de horario');
    }
};

export const obtieneDetalleComunicaConfig = async (comunicaConfigId) => {
    //
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/comunicaDetalle/comunica/${comunicaConfigId}`, obtenerConfig());
        return formatoFechasList(response.data);
    } catch (error) {
        console.error('Error: ', error.message);
        throw new Error('Error al recuperar Datos');
    }
};

export const buscaConfiguracionHorario = async (puestoId, horaDetId) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/comuniconfig/puestoHoraDet/${puestoId}/${horaDetId}`, obtenerConfig());
        //console.log('XXxx01:', response.data);
        return response.data;
    } catch (error) {
        //console.log('XXxx02:')
        console.log('Error o no hay datos');
        return [];
    }
};

export const creaComunicaConfigDetalle = async (objPost) => {
    //console.log ('XX00:', objPost)
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/comunicaDetalle/detalle`, objPost, obtenerConfig());
        //console.log('XZXZ00:', response.data);
        const dataSalida = formatoFechasList(response.data);
        return dataSalida;
    } catch (error) {
        console.error('Error: ', error.message);
        throw new Error('Error al recuperar Datos');
    }
};

const formatoFechasList = (lstOriginal) => {
    let horaAnterior = null;
    //const fechaTrabajo = new Date(); //fecha de hoy
    let fechaTrabajo = null;
    const dataSalida = lstOriginal.map((item) => {
        const { hour, minute, second } = item.horaComunica;
        const horaString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}`;
        //console.log('ZZZ00:', horaString);
        if (fechaTrabajo === null) {
            const esNocturno = item.comunicacionConfig.horarioDetalle.esNocturno;
            fechaTrabajo = new Date();
            if (esNocturno) {
                const horaActual = fechaTrabajo.getHours();
                if (horaActual >= 0 && horaActual <= 11) {
                    fechaTrabajo.setDate(fechaTrabajo.getDate() - 1);
                }
            } else {
                fechaTrabajo = new Date();
            }
        }
        if (horaAnterior === null) {
            // inicia con la Hora inicial del Horario
            const horaInicial = item.comunicacionConfig.horarioDetalle.horaInicio;
            //console.log('ZZZ01:', horaInicial);
            horaAnterior = horaInicial.hour;
        }
        if (horaAnterior !== null && hour < horaAnterior) {
            fechaTrabajo.setDate(fechaTrabajo.getDate() + 1);
        }
        horaAnterior = hour;
        const fechaOrden = new Date(fechaTrabajo.getFullYear(), fechaTrabajo.getMonth(), fechaTrabajo.getDate(), hour, minute, second);
        return {
            comunicacionConfigDetalleId: item.comunicacionConfigDetalleId,
            horaComunica: horaString,
            secuencia: item.secuencia,
            fechaOrden: fechaOrden
        };
    });
    return dataSalida;
};

export const obtieneInfConfig = async () => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/comuniconfig/informe`, obtenerConfig());
        //console.log('JJ900:', response.data)
        return response.data;
    } catch (error) {
        console.error('Error: ', error.message);
        throw new Error('Error al recuperar Datos');
    }
};

export const obtieneUsuOperadores = async () => {
    //console.log ('WWJ00: Iniciando')
    try {
        const codeOperador = 'ROL-0000-0000-0010';
        const response = await axios.get(`${URL_BASE_MONITOREO}/usuarioRol/rol/${codeOperador}`, obtenerConfig());
        //console.log ('WWJ01: ', response.data)
        const codeSupervisor = 'ROL-0000-0000-0009';
        const response2 = await axios.get(`${URL_BASE_MONITOREO}/usuarioRol/rol/${codeSupervisor}`, obtenerConfig());
        //console.log ('WWJ02: ', response2.data)
        const salida = [...response.data, ...response2.data];
        //console.log ('WWJ03: ', salida)
        return salida;
    } catch (error) {
        console.error('Error: ', error.message);
        throw new Error('Error al recuperar Datos');
    }
};

export const registraAcceso = async (objPost) => {
    //console.log('jj900:', objPost)
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/usuarioPuesto/creaAccesos`, objPost, obtenerConfig());
        //console.log('jj901:', response)
    } catch (error) {
        console.error('Error: ', error.message);
        throw new Error('Error al registrar los datos');
    }
};

export const obtieneUsuarioPuesto = async () => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/usuarioPuesto`, obtenerConfig());
        //console.log('qzq00:', response.data)
        const lstsalida = response.data.map((item) => {
            return {
                usuarioId: item.usuarioId,
                usuarioName: item.usuarioName,
                usuarioPuestoId: item.usuarioPuestoId,
                clienteId: item.puesto.proyecto.clienteId.clienteId,
                clienteSigla: item.puesto.proyecto.clienteId.nombre,
                puestoId: item.puesto.puestoId,
                puestoSigla: item.puesto.sigla,
                puestoNombre: item.puesto.nombre,
                proyectoSigla: item.puesto.proyecto.sigla,
                proyectoNombre: item.puesto.proyecto.nombre
            };
        });
        return lstsalida;
    } catch (error) {
        console.error('Error: ', error.message);
        throw new Error('Error al obtener los datos');
    }
};

export const borraListaUsuPuesto = async (objData) => {
    //console.log('KWKW: ', objData);
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/usuarioPuesto/borraLote`, objData, obtenerConfig());
        //console.log('QXXQ:', response)
    } catch (error) {
        console.error('Error: ', error.message);
        throw new Error('Error al tratar de borrar');
    }
};

export const obtenerHorariosConDetalle = async () => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/horariodet/horariosConDetalle`, obtenerConfig());
        //console.log('QXXQ:', response.data)
        return response.data;
    } catch (error) {
        console.error('Error: ', error.message);
        throw new Error('Error al Traer Horarios con detalle');
    }
};


export const getAllComunicaConfig = async () => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/comuniconfig`, obtenerConfig());
        const lstSalida = response.data.map((item) => {
            let cadenaDias = ''
            if (item.lunes) {
                cadenaDias = cadenaDias + 'L-'
            }
            if (item.martes) {
                cadenaDias = cadenaDias + 'M-'
            }
            if (item.miercoles) {
                cadenaDias = cadenaDias + 'Mi-'
            }
            if (item.jueves) {
                cadenaDias = cadenaDias + 'J-'
            }
            if (item.viernes) {
                cadenaDias = cadenaDias + 'V-'
            }
            if (item.sabado) {
                cadenaDias = cadenaDias + 'S-'
            }
            if (item.domingo) {
                cadenaDias = cadenaDias + 'D-'
            }
            if (cadenaDias.length > 0) {
                cadenaDias = cadenaDias.slice(0,-1)
            }
            if (cadenaDias === 'L-M-Mi-J-V-S-D') {
                cadenaDias = 'Diario'
            }
            return {
                comunicaConfigId: item.comunicaConfigId,
                proyectoId: item.puesto.proyecto.proyectoId,
                proyectoSigla: item.puesto.proyecto.sigla,
                proyectoNombre:  item.puesto.proyecto.nombre,
                puestoId: item.puesto.puestoId,
                puestoSigla: item.puesto.sigla,
                puestoNombre: item.puesto.nombre,
                horarioSigla: item.horarioDetalle.horario.sigla,
                horarioNombre: item.horarioDetalle.horario.nombre,
                horarioDescripcion: item.horarioDetalle.horario.sigla + '-' + item.horarioDetalle.horario.nombre,
                horarioDetalle:
                    String(item.horarioDetalle.horaInicio.hour).padStart(2, '0') +
                    ':' +
                    String(item.horarioDetalle.horaInicio.minute).padStart(2, '0') +
                    '-' +
                    String(item.horarioDetalle.horaFin.hour).padStart(2, '0') +
                    ':' +
                    String(item.horarioDetalle.horaFin.minute).padStart(2, '0'),
                cantidadVeces: item.cantidadVeces,
                esAleatorio: item.esAleatorio ? 'SI' : 'NO',
                limInf: item.esAleatorio ? item.randomLimInf : 0,
                limSup: item.esAleatorio ? item.randomLimSup : 0,
                dias: cadenaDias
            };
        });
        //console.log('KK19=', lstSalida);
        return lstSalida;
    } catch (error) {
        console.error('Error: ', error.message);
        throw new Error('Error al Obtener las configuraciones');
    }
};

export const borrarConfigPorLista = async (objPost) => {
    //
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/comuniconfig/eliminaByList`, objPost, obtenerConfig());
        //console.log('QQ0=', response.data);
        return response.data;
    } catch (error) {
        console.error('Error: ', error.message);
        throw new Error('Error al Borrar las configuraciones');
    }
};

export const getHorarioByPuesto = async (objPost) => {
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/turnotrabajo/horarios`, objPost, obtenerConfig());
        //console.log('00= ', response.data)
        return response.data
    } catch (err) {
        console.error('Error: ', err.message);
        throw new Error('Error al traer los horarios.');
    }
}
